import React from 'react'
import JoinInForm from './JoinInForm';
import HeaderBannerPages from '../HeaderBannerPages/HeaderBannerPages';

const JoinAsPartner = () => {
  return (
    <>
    <HeaderBannerPages text="Become Partner" />

    <JoinInForm />
    
    </>
  )
}

export default JoinAsPartner;